import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const ALLOWED_STANDALONE_PATHS = new Set([
  "/login",
  "/q",
  "/q/new",
  "/q/leads",
  "/q/leads/shortlisted",
  "/admin",
  "/admin/users",
]);

function isStandaloneDisplay() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia?.("(display-mode: standalone)")?.matches ||
    window.navigator.standalone === true
  );
}

export default function StandaloneRedirect() {
  const history = useHistory();
  const location = useLocation();
  const { user, profile } = useAuth();

  useEffect(() => {
    if (!isStandaloneDisplay()) return;

    const path = location.pathname;
    
    // Check exact path match
    const hasExactAccess = ALLOWED_STANDALONE_PATHS.has(path);
    
    // Check path prefix access for authenticated users
    let hasPrefixAccess = false;
    if (user && profile) {
      // Sales users can access all routes under /q/
      if (profile.role !== "admin" && path.startsWith("/q/")) {
        hasPrefixAccess = true;
      }
      // Admin users can access all routes under /admin/
      if (profile.role === "admin" && path.startsWith("/admin/")) {
        hasPrefixAccess = true;
      }
    }
    
    const hasAccess = hasExactAccess || hasPrefixAccess;

    if (user && profile) {
      const dashboard = profile.role === "admin" ? "/admin" : "/q";
      if (!hasAccess && path !== dashboard) {
        history.replace(dashboard);
      }
    } else if (!hasAccess || path !== "/login") {
      history.replace("/login");
    }
  }, [history, location.pathname, user, profile]);

  return null;
}


